import { render, staticRenderFns } from "./FurtherReading.vue?vue&type=template&id=1b6cfb28&scoped=true&lang=pug&"
import script from "./FurtherReading.vue?vue&type=script&lang=js&"
export * from "./FurtherReading.vue?vue&type=script&lang=js&"
import style0 from "./FurtherReading.vue?vue&type=style&index=0&id=1b6cfb28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6cfb28",
  null
  
)

export default component.exports